<script>
import Base from '@/plans/ZOOM_ROOMS/config/base';
import addonMixin from '@/plans/mx/addon';
import { mapGetters } from 'vuex';
import { dateTimeFormat } from '@/utils/dateformat.js';
import { DEFAULT_MIN_HOST } from '@/common/constants';
import { validDownSellLicense } from '@/utils/validate-downsell';
import audioUsCaMixin from '@/common/mixin/audio-us-ca-mixin';

export default {
  extends: Base,
  mixins: [addonMixin, audioUsCaMixin],
  data() {
    return {
      showCycleAlert: true,
    };
  },
  computed: {
    ...mapGetters(['basicConfig', 'currentEditPlan']),
    disabledForBulkLicense() {
      return (cycle) => {
        return this.basicConfig?.isBulkLicenseAccount && this.currentEditPlan?.billing_cycle !== cycle;
      };
    },
    previousQuantity() {
      return this.currentEditPlan?.cartInfo?.selected_number ?? DEFAULT_MIN_HOST;
    },
    minHosts() {
      if (this.disableDownSell) return this.previousQuantity;
      return this.mx_minHosts;
    },
    maxHosts() {
      const editMaxQuantity = 9999;
      const quantity = this.currentEditPlan?.cartInfo?.selected_number;
      return quantity <= editMaxQuantity ? editMaxQuantity : quantity;
    },
    disableDownSell(){
      return this.basicConfig.downSellData.disableDownSell;
    },
    decreaseTips() {
      if (this.selectedNumber === this.previousQuantity && this.disableDownSell) {
        return this.$t('billing.error.can_not_bought_plan_tips');
      }

      return this.mx_decreaseTips || this.forNonStandardPriceTips;
    },
  },
  watch: {
    selectedNumber: {
      immediate: true,
      handler(license) {
        const {
          assignLicenseQuantity = 0,
          needAssignQuantity = 0,
          planExpireTime,
        } = validDownSellLicense({ quantity: license });
        if (needAssignQuantity > 0) {
          this.mx_licenseAlert = this.$t('billing.zr.remove_assigned_license', [
            assignLicenseQuantity,
            needAssignQuantity,
            dateTimeFormat(planExpireTime),
          ]);
        } else {
          this.mx_licenseAlert = '';
        }
      },
    },
  },
};
</script>
